import script from "./moreJobKinds.vue?vue&type=script&setup=true&lang=js"
export * from "./moreJobKinds.vue?vue&type=script&setup=true&lang=js"

import "./moreJobKinds.vue?vue&type=style&index=0&id=32b0a427&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b0a427"]])

export default __exports__